module.exports = __webpack_public_path__ + "img/portada11.9ae70f3d.jpeg";